export default class ResultPresentationType {

    /**
     * The static get Pagination function returns an instance of the 'Pagination' class.
     * @returns The method is returning an instance of the 'Pagination' class.
     */
    static get Pagination() {
      return this.getInstance('Pagination');
    }
  
    /**
     * The function returns an instance of the 'InfiniteScrolling' class.
     * @returns The method `get InfiniteScrolling()` is returning the result of calling the `getInstance`
     * method with the argument `'InfiniteScrolling'`.
     */
    static get InfiniteScrolling() {
      return this.getInstance('InfiniteScrolling');
    }
    
    /**
     * The function "fromKey" takes a key as input and returns the corresponding value from a
     * predefined map.
     * @param key - The `key` parameter is a string that represents a key in the `statusMap` object.
     * @returns The value associated with the given key in the statusMap object is being returned.
     */
    static fromKey(key) {
      const statusMap = {
        'Pagination': ResultPresentationType.Pagination,
        'InfiniteScrolling': ResultPresentationType.InfiniteScrolling,
      };
      return statusMap[key];
    }
  
    /**
     * Gets an instance of a ResultPresentationType object based on a given name.
     * If the instance does not already exist, it creates a new instance using the configuration provided.
     *
     * @param name a unique identifier used to retrieve or create an instance of the ResultPresentationType class.
     * @param configuration an object that contains various properties and values that are used to configure
     * the instance of the ResultPresentationType class that is being created.
     *
     * @returns an instance of `ResultPresentation` that corresponds to the given `name`.
     */
    static getInstance(key) {
      if (!this.instances[key]) {
        this.instances[key] = new ResultPresentationType(key);
      }
      return this.instances[key];
    }
  
    /**
     * This is a constructor function that takes a name as a parameter and sets the name
     * @param name -The `name` property is a string that represents the name of the
     * configuration
     */
    constructor(name) {
      this.name = name;
    }
  
    /**
     * Method that returns the name property of an object as a string.
     * @returns returns the `name` property of that object as a string.
     */
    toString() {
      return `${this.name}`;
    }
  }
  
  Object.defineProperty(ResultPresentationType, 'instances', { value: {} });
  